import { useMemo } from 'react';
import { ProductAvailability } from '@mango-engineering/maknet-client-sdk/lib/shop/product/util/statusUtils';
import { ShoppingDataLayerProduct } from '@makro-shopping/use-product-card-logic/dist/types/product.type';
import { useStaticData } from '../contexts/DataProvider.context';
import { Product, ProductSearchResult } from '../types/product.types';

interface IHideAlcoholProductPrice {
  product: Product | ProductSearchResult | undefined | ShoppingDataLayerProduct;
  productStatus: string | undefined;
  hideAlcoholProductPrice: boolean;
}

export function useHideAlcoholProductPrice({
  product,
  productStatus,
  hideAlcoholProductPrice,
}: IHideAlcoholProductPrice): boolean {
  const { userDetails } = useStaticData();

  const isAlcohol = product?.isAlcohol ?? false;
  const isNotEligible = productStatus === ProductAvailability.notEligible;

  return useMemo(() => {
    if (isAlcohol) {
      if (!hideAlcoholProductPrice) {
        return false;
      }
      if (!userDetails?.token || isNotEligible) {
        return true;
      }
    }
    return false;
  }, [hideAlcoholProductPrice, isAlcohol, isNotEligible, userDetails?.token]);
}
